module.exports = __webpack_public_path__ + "img/t2-c15.007b0bac.png";